import { render, staticRenderFns } from "./Worklist_new.vue?vue&type=template&id=b365fd34&scoped=true"
import script from "./Worklist_new.vue?vue&type=script&lang=js"
export * from "./Worklist_new.vue?vue&type=script&lang=js"
import style0 from "./Worklist_new.vue?vue&type=style&index=0&id=b365fd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b365fd34",
  null
  
)

export default component.exports